const FileManager = () =>
  import(
    /* webpackChunkName: "system-file-and-documents" */ '@/pages/system/file-and-documents/index.vue'
  )
const FileManagerEdit = () =>
  import(
    /* webpackChunkName: "system-file-and-documents" */ '@/pages/system/file-and-documents/media.vue'
  )

export default {
  path: 'file-and-documents',
  meta: {
    label: 'fileAndDocuments',
    auth: 'doc'
  },
  component: {
    name: 'FileAndDocuments',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemFileAndDocuments',
      path: '',
      meta: {
        label: 'report',
        auth: 'root'
      },
      component: FileManager
    },
    {
      name: 'SystemEditFileAndDocuments',
      path: ':root',
      meta: {
        label: 'edit',
        auth: true
      },
      props: true,
      component: FileManagerEdit
    }
  ]
}
